import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import useSession from "../../../hooks/useSession";
import NavMenu from "./NavMenu";
import logoImg from "../../../assets/logo-Innovia.png";

function Navbar({ adminPage }) {
  const [user, loading] = useSession();
  const navigate = useNavigate();

  const handleSignOut = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <div className="w-full h-64 bg-[#F5F5F5]">
      <div
        className={`navbar text-white h-24 flex items-center ${
          adminPage ? "justify-between" : "justify-end"
        } px-7 md:px-12 pt-4`}
      >
        {adminPage && (
          <div className="ml-2 md:ml-14 pt-3">
            <Link to="/">
              <img src={logoImg} alt="logo" className="w-[10rem] drop-shadow-lg" />
            </Link>
          </div>
        )}
        <div
          className={`flex flex-col items-center pt-3 ${
            adminPage ? "md:mr-14" : ""
          }`}
        >
          <NavMenu
            user={user}
            loading={loading}
            handleSignOut={handleSignOut}
          />
          {/* <span className="text-base text-[#DB0029] font-bold hidden md:block">
            {user?.name ? user?.name : "User"}
          </span> */}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
